module.exports = __webpack_public_path__ + "media/images/gli-logo-abf3fdadbab1bfa47339584fd947ae52.png";